import React from 'react';
import styled from 'styled-components';
import { invokeLater, useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { ContainerScope, resolve, useResolve } from '../../Container';
import { Camera, CameraState } from '../Camera';
import { Burdens } from '../extensibility/Burdens';

const OriginRoot = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    will-change: contents;
`;

export class Origin extends React.Component<{ fixInitialLoadBug?: boolean, children?: React.ReactNode }> {

    public static contextType = ContainerScope;

    public state = {
        ready: false
    };

    @resolve(Camera) camera: Camera;

    private burdens = new Burdens();
    private elmt = React.createRef<HTMLDivElement>();

    public render() {
        return <OriginRoot className={this.state.ready ? 'layer surface' : ''} ref={this.elmt}>
            {this.state.ready && this.props.children}
        </OriginRoot>;
    }

    public componentDidMount() {
        this.burdens.add(this.camera.observe(this.setTransformForCameraState));

        const init = () => {
            this.setTransformForCameraState(this.camera.getState());
            this.setState({ ready: true });
        };

        if (this.props.fixInitialLoadBug) {
            invokeLater(100, init);
        }
        else {
            init();
        }
    }

    public componentWillUnmount = () => this.burdens.destroy();

    private setTransformForCameraState = (cs: CameraState) => {
        if (!this.elmt?.current) return;
        this.elmt.current.style.transform = `scale(${cs.scale}) translate(${cs.position.x * -1}px, ${cs.position.y * -1}px)`;
    };
}

export const SimpleOrigin: LFC = ({ children }) => {
    const cs = useObserver(useResolve(Camera));
    return <OriginRoot style={{ transform: `scale(${cs.scale}) translate(${cs.position.x * -1}px, ${cs.position.y * -1}px)` }}>
        {children}
    </OriginRoot>
}

export const ReverseOrigin: LFC = ({ children }) => {
    const cs = useObserver(useResolve(Camera));
    return <OriginRoot style={{ transform: `translate(${cs.position.x}px, ${cs.position.y}px) scale(${cs.scale * -1})` }}>
        {children}
    </OriginRoot>
}